import React from "react";
import { getSdk } from "../../services/sdkService";
import { EpisodesSelector, withFocusable, Loading } from "../../services/visualLibraryService";
import { DetailPageStyled, ArrowScrollStyled } from "./styles/Styled";
import { getSeasonsAndEpisodesList } from "../../utils/mediaDataRetrieval";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { showAndReportUserRelatedError } from "../../errors/utils";
import { getGlobalButtonInfo, getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { resolution } from "../../config/ui/resolutionConfig";
import { historyMethods } from "../../utils/historyMethods";
import { getSpSportsPackageDisplayName, isSpSportsAddonContent } from  "../../services/sportPackageService"; 
import {
  showChannelSubscriptionErrorPopupNew,
  isUserSubscribedToChannel,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom
} from "../../utils/subscriptionUtils";
import { redirectTo } from "../../services/navigationService";
import { getEpisodeLabel } from "../../services/copyService";
import { isSuitableFor4KPlayback } from "../../services/titleDataService";
import { showResolutionModal, showNotLoggedModal, showInvalidStatusModal } from "../../services/modalsService"; 
import { routes } from "../../routes";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";

const PAGE = "episodeSelector";
const PLAY_FROM_LABEL = "details_episode_screen";
const ArrowScrollFocus = withFocusable(ArrowScrollStyled);
let sdk = null;

class EpisodesSelectorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isLoading: false
    };
    this.episodeTitle = {};
    this.isLeaving = false;
    this.isMagicRemoteActive = false;
    this.handleEnter = this.handleEnter.bind(this);
    this.play = this.play.bind(this);
    this.getVideoData = this.getVideoData.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  async componentDidMount() {
    this.mounted = true;
    sdk = await getSdk();
    trackPage.call(this, PAGE);
    await this.checkUpdatedEpisodes();
    this.props.onRef(this);
    this.props.setFocus(EpisodesSelector.defaultFocusPath);
  }

  async componentDidUpdate() {
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  async checkUpdatedEpisodes() {
    const {
      history: {
        location: { state, referrer }
      }
    } = this.props;
    if (referrer === routes.player) {
      try {
        const updatedEpisodes = await getSeasonsAndEpisodesList(state.seriesId, true);
        Object.assign(state, {
          episodesList: state.episodesList.map((episode, index) =>
            Object.assign(episode, updatedEpisodes.episodesList[index])
          ),
          lastEpisode: updatedEpisodes.lastEpisode
        });
        this.setState({ isLoaded: true });
      } catch (e) {
        this.setState({ isLoaded: true });
      }
    }
    this.setState({ isLoaded: true });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async handleEnter(episodeTitle) {
    const currentAddOn = getAddOnByName(episodeTitle.addonContent);
    const {
      applicationState: { userLogged, userAccountStatus, addons }
    } = this.props;
    if (userLogged) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(episodeTitle.addonContent)) {
        return showInvalidStatusModal.call(this);
      }
      if(isCricketAddOn(episodeTitle.addonContent) && isCricketAcquiresFrom(episodeTitle.addonContent)){
        if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent) && isT20ChildSubscribed(episodeTitle.addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent) && !isT20ChildSubscribed(episodeTitle.addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${currentAddOn.displayName} & ${CricChildAddOn(episodeTitle.addonContent)?.displayName}`);
        } 
      } else if (isT20AddOn(episodeTitle.addonContent)) {
        if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent) && isT20ParentSubscribed(episodeTitle.addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent) && !isT20ParentSubscribed(episodeTitle.addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${T20ParentAddOn(episodeTitle.addonContent)?.displayName} & ${currentAddOn.displayName}`);
        } 
      } else {
          if (isMainPackageAddOn(episodeTitle.addonContent) && isSpSportsAddonContent(episodeTitle.addonContent) && !isUserSubscribedToSpSportsChannel(addons, episodeTitle.addonContent)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isMainPackageAddOn(episodeTitle.addonContent) && !isStandAloneAddon(episodeTitle.addonContent) && isSpSportsAddonContent(episodeTitle.addonContent) && !isUserSubscribedToSpSportsChannel(addons, episodeTitle.addonContent)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent)) {
            return showChannelSubscriptionErrorPopupNew.call(this, this.closeModal);
        }
      }

      this.setState({
        isLoaded: false
      }, async () => {
        const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, episodeTitle.addonContent);
        this.setState({ isLoaded: true });
        if (!isThisDeviceSupported) {
          return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
        }
        this.episodeTitle = episodeTitle;
        showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
      });

    } else {
      showNotLoggedModal.call(this, {
        nextPageReference: { navigationMode: historyMethods.GO_BACK }
      });
    }
    return false;
  }

  onBack() {
    if (!!getAppState().globalModal) {
      this.closeModal();
      return true;
    }
    return false;
  }

  closeModal() {
    const {
      stateActions: { hideGlobalModal },
      setFocus
    } = this.props;
    hideGlobalModal();
    setFocus(EpisodesSelector.defaultFocusPath);
  }

  async play(is4K, isSelectedFromResolutionPopup) {
    const {
      location: {
        state: { seriesId }
      },
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    !!getAppState().globalModal && hideGlobalModal();
    const videoData = await this.getVideoData(is4K);
    if (this.mounted) {
      isSelectedFromResolutionPopup && trackEvent("detail", is4K ? "4K" : "HD", seriesId);
      trackEvent(
        "detail",
        "play_from_episode_selector",
        `${seriesId}-S${this.episodeTitle.tvSeasonNumber}E${this.episodeTitle.tvSeasonEpisodeNumber}`
      );
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      setFocus(EpisodesSelector.defaultFocusPath);
      redirectTo.call(this, routes.player, videoData);
    }
  }

  async get4KMediaContent(id) {
    let title;
    try {
      const { location } = this.props;
      if (location.state.episodesList && location.state.episodesList.length) {
        title = location.state.episodesList.find(episode => !!episode["4kProgramId"] && episode["4kProgramId"] === id);
      } else {
        title = await sdk.mediaManager.getTitle(id, { is4K: true });
      }
      return title.title4K ? title.title4K.mediaContent[0] : title.mediaContent[0];
    } catch (e) {
      if (this.mounted) {
        showAndReportUserRelatedError.call(this, {
          modalText: i18n.get("global.errors.genericError"),
          buttons: [
            {
              ...getGlobalButtonInfo("close"),
              buttonHandler: this.closeModal
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    }
  }

  // FIXME There is a really similar function in DetailPage.js, we should have the logic in one place only
  async getVideoData(is4K) {
    const { location } = this.props;
    const media = is4K
      ? await this.get4KMediaContent(this.episodeTitle["4kProgramId"])
      : this.episodeTitle.mediaContent[0];
    return {
      videoType: "series",
      manifest: media.content.video.streamingUrl,
      releasePid: media.content.video.releasePid,
      releaseUrl: media.content.video.releaseUrl,
      duration: media.content.video.duration,
      filmstrip: media.content.filmstrip,
      description: this.episodeTitle.shortDescription || this.episodeTitle.description,
      title: this.episodeTitle.title,
      tvSeasonNumber: this.episodeTitle.tvSeasonNumber,
      tvSeasonEpisodeNumber: this.episodeTitle.tvSeasonEpisodeNumber,
      playbackTime: this.episodeTitle.progress && this.episodeTitle.progress.playbackTime,
      seriesTitle: location.state.seriesTitle,
      episodeLabel: getEpisodeLabel(this.episodeTitle.tvSeasonNumber, this.episodeTitle.tvSeasonEpisodeNumber),
      seasonsList: this.seasonsList,
      episodesList: location.state.episodesList,
      id: this.episodeTitle.id,
      seriesId: location.state.seriesId,
      moduleId: location.state.moduleId,
      has4K: location.state.has4K,
      //externalSubtitles: is4K && media.content.subtitles
      externalSubtitles: media.content.subtitles,
      mediaGuid: media.mediaGuid,
      credits: media.credits,
      playFrom: PLAY_FROM_LABEL
    };
  }

  goBack() {
    this.props.stateActions.setCurrentFocus("buttonPlay");
    this.props.setFocus("buttonPlay");
    !this.isLeaving && this.props.history.goBack();
    this.isLeaving = true;
  }

  render() {
    const {
      location: {
        state: { seasonsList, episodesList, lastEpisode, backgroundCover, seriesTitle }
      }
    } = this.props;
    this.seasonsList = seasonsList;

    return (
      <DetailPageStyled url={backgroundCover}>
        {this.state.isLoaded ? (
          <>
            <ArrowScrollFocus
              label={seriesTitle}
              icon="arrowUp"
              focusPath="backArrowScrollFocus"
              onFocus={this.goBack} // FIXME: To use onFocus there are some issues with focus management to be solved.
            />
            <EpisodesSelector
              seasonSelected={lastEpisode && lastEpisode.tvSeasonNumber}
              episodeSelected={lastEpisode && lastEpisode.tvSeasonEpisodeNumber}
              seasonsList={this.seasonsList}
              episodesList={episodesList}
              MagicRemoteStatus={this.isMagicRemoteActive}
              onEnterPress={this.handleEnter}
              direction={i18n.getDirection()}
              onUp={this.goBack}
              slideMarginStart={resolution.carousel.slideMarginStart.episodeSelector}
            />
          </>
        ) : (
          <Loading overlay />
        )}
      </DetailPageStyled>
    );
  }
}

const Component = withAppState(withSubtheme(EpisodesSelectorPage));

Component.defaultFocusPath = EpisodesSelector.defaultFocusPath;

export default Component;
